import { AxiosError } from 'core/utils/hcAxios'
import { TLanguages } from 'core/config/locale'
import { HandledError } from 'core/types'
import { useCallback, useRef } from 'react'
import { dispatchLogout } from 'core/components/Authenticate'

interface ExtendedAxiosError extends AxiosError {
  data?: {
    code?: number
    msg?: string
  }
}

export interface ErrorNotifier {
  notify: (message: string) => void
}

const useAxiosResponseErrorHandler = (lang: TLanguages, errorNotifier: ErrorNotifier) => {
  const errorNetworkAlertTimer = useRef<NodeJS.Timeout | null>(null)
  const errorAuthAlertTimer = useRef<NodeJS.Timeout | null>(null)

  const axiosResponseErrorHandler = useCallback(
    async (error: ExtendedAxiosError) => {
      if (error.code === 'ERR_NETWORK') {
        if (errorNetworkAlertTimer.current) {
          clearTimeout(errorNetworkAlertTimer.current)
        }
        errorNetworkAlertTimer.current = setTimeout(() => {
          errorNotifier.notify('Network error~')
        }, 100)
        return Promise.reject(error)
      }

      const message = error?.data?.msg || error?.response?.data?.msg
      if (error.response?.status === 401 || error.data?.code === 401) {
        dispatchLogout()

        if (errorAuthAlertTimer.current) {
          clearTimeout(errorAuthAlertTimer.current)
        }
        errorAuthAlertTimer.current = setTimeout(() => {
          errorNotifier.notify(message)
        }, 200)
        return Promise.reject(error)
      }

      if (message) {
        errorNotifier.notify(message)
        return Promise.reject(new HandledError(message || 'request error'))
      }
      return Promise.reject(error)
    },
    [errorNotifier]
  )

  return axiosResponseErrorHandler
}

export default useAxiosResponseErrorHandler
